import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";

export const Route = createFileRoute("/thank-you")({
  head: () => ({
    meta: [
      { title: "Thank You | MLC Epoxy Floors" },
      { name: "robots", content: "noindex,nofollow" },
      { name: "description", content: "Your quote request was received. We'll be in touch within one business day." },
    ],
  }),
  component: ThankYouPage,
});

function ThankYouPage() {
  return (
    <section className="container-x py-24">
      <div className="mx-auto max-w-xl rounded-sm border border-copper/40 bg-charcoal p-10 text-center">
        <CheckCircle2 className="mx-auto h-14 w-14 text-copper" />
        <h1 className="mt-6 text-3xl text-silver-light">Quote Request Received</h1>
        <p className="mt-3 text-silver">
          Thanks — a member of our team will reach out within one business day to schedule your free in-person estimate.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center justify-center rounded-sm border border-copper px-6 py-3 text-xs font-bold uppercase tracking-widest text-copper hover:bg-copper hover:text-white transition-colors"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
}
